// :cow: Cosmose CONFIDENTIAL :iso:
import { ReportMetricsType } from '@med/app/home/campaign/modules/report/model/report-metrics-type';
import { CampaignStatsReportTypeEnum } from '@med/app/home/campaign/model/campaign-stats-report-type.enum';
import { DateRange } from '@med/app/home/campaign/modules/report/model/date-range';

export interface ReportState {
  reportMetricsType: ReportMetricsType;
  reportType: CampaignStatsReportTypeEnum;
  metricsTypes: ReportMetricsType[];
  reportDateRange: DateRange,
  audienceSegment: string,
}

export const initialState: ReportState = {
  reportMetricsType: ReportMetricsType.all,
  reportType: CampaignStatsReportTypeEnum.perDay,
  metricsTypes: undefined,
  reportDateRange: undefined,
  audienceSegment: undefined,
};
